import { ControlPropertyType } from '../enums';
import { StyleColorSchemeType } from '../../../../styles/enums';

const ControlProps = {
  props: {
    [ControlPropertyType.Name]: {
      type: String,
      default: '',
    },
    [ControlPropertyType.Id]: {
      default: '',
      type: String,
    },
    [ControlPropertyType.Value]: {
      type: [String, Number, Object, Array, Date, Boolean, () => (File)],
      default: '',
    },
    [ControlPropertyType.Disabled]: {
      type: Boolean,
      default: false,
    },
    [ControlPropertyType.Placeholder]: {
      type: String,
      default: '',
    },
    [ControlPropertyType.Label]: {
      type: String,
      default: '',
    },
    [ControlPropertyType.Error]: {
      type: String,
      default: '',
    },
    [ControlPropertyType.ColorScheme]: {
      type: String,
      default: StyleColorSchemeType.Secondary,
    },
    [ControlPropertyType.Inline]: {
      type: Boolean,
      default: false,
    },
  },
};

export default ControlProps;
